import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

/*
-> Campo de valor monetário com máscara (dígitos são tratados como centavos, igual
   VFieldMoneyNumber2), mas como componente controlado comum — pra usar fora de um VForm
   (ex.: diálogos com useState simples). Dentro de um VForm, use VFieldMoneyNumber2.

  <MoneyTextField
    label='Valor'
    value={valor}
    onChange={setValor}
  />
*/
interface IMoneyTextFieldProps extends Omit<TextFieldProps, 'value' | 'onChange'> {
  value: number;
  onChange: (value: number) => void;
}

const formatToBR = (value: number) =>
  value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const MoneyTextField: React.FC<IMoneyTextFieldProps> = ({ value, onChange, ...rest }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digitsOnly = e.target.value.replace(/\D/g, '');
    const numberValue = Number(digitsOnly) / 100;
    onChange(numberValue);
  };

  return (
    <TextField
      {...rest}
      value={formatToBR(value)}
      onChange={handleChange}
      inputProps={{ inputMode: 'numeric', ...rest.inputProps }}
    />
  );
};
